import React, { Component, Fragment } from 'react'
import Breadcrumb from '../../common/breadcrumb';
import { ToastContainer, toast } from 'react-toastify';
import sweetAlert from 'sweetalert'
import axios from 'axios'
const loc = window.location.href;
const defaultStateImage = {
    CourseOptput: {},
    ImageFiles: [],
    loadingImage: false,
    imgUploadPercentage: 0,
    imgSaveDisable: false,
}
export default class AddZipCourses extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dirname: ('dir' + Math.random(0, 9)).toString(),
            courseId: loc.substring(loc.lastIndexOf('/') + 1),
            CourseOptput: {},
            ImageFiles: [],
            ZipUploded: {},
            loadingZip: false,
            loadingImage: false,
            zipUploadPercentage: 0,
            imgUploadPercentage: 0,
            zipSaveDisable: false,
            imgSaveDisable: false,


        }
    }
    componentDidMount() {
        if (!localStorage.getItem('userInfo')) {
            window.location.href = '/admin';
        }

        this.fetchCourse();
    }
    fetchCourse = () => {
        fetch(`${process.env['REACT_APP_HOST']}/api/products/${this.state.courseId}`)
            .then((response) => response.json())
            .then(result => {
                this.setState({ CourseOptput: result });

            });
    }
    uploadZipHandler = async (e) => {
        this.setState({ ZipUploded: e.target.files[0], zipSaveDisable: false })
        return

    }
    resetState = () => {
        this.setState({ ...this.state, ...defaultStateImage })
    }
    saveZip = async () => {
        if (this.state.ZipUploded.name) {
            this.setState({ loadingZip: true, zipSaveDisable: true })
            const formData = new FormData()
            formData.append('zip', this.state.ZipUploded)
            let _this = this;
            // setUploading(true)
            try {
                const config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'dirname': this.state.CourseOptput.dirname,
                        'filename': 'webgl',
                        'courseId': this.state.courseId
                    },
                    onUploadProgress: (progressEvent) => {
                        const { loaded, total } = progressEvent;
                        const percentage = Math.floor((loaded * 100) / total);
                        console.log("progress : ", percentage);
                        this.setState({ zipUploadPercentage: percentage })
                    }
                }
                const { data } = await axios.post(`${process.env['REACT_APP_HOST']}/api/upload/zip`, formData, config)

                this.setState({ loadingZip: false, zipUploadPercentage: 0 })
                if (data.error) {
                    toast.error("Please Retry.")
                    return
                }
                _this.fetchCourse()
                toast.success("Successfully Uploaded !")

            } catch (error) {
                toast.error("Please Retry.")
                this.setState({ zipUploadPercentage: 0 })
            }
        }
    }
    saveImages = async () => {
        if (this.state.ImageFiles.length > 0) {
            this.setState({ loadingImage: true, imgSaveDisable: true })
            const formData = new FormData()
            for (let i = 0; i < this.state.ImageFiles.length; i++) {
                formData.append("images", this.state.ImageFiles[i]);
            }
            let _this = this;
            // setUploading(true)
            try {
                const config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'dirname': this.state.CourseOptput.dirname,
                        'filename': 'image',
                        'courseId': this.state.courseId
                    },
                    onUploadProgress: (progressEvent) => {
                        const { loaded, total } = progressEvent;
                        const percentage = Math.floor((loaded * 100) / total);
                        console.log("progress : ", percentage);
                        this.setState({ imgUploadPercentage: percentage })
                    }
                }
                const { data } = await axios.post(`${process.env['REACT_APP_HOST']}/api/upload/images`, formData, config)
                this.setState({ loadingImage: false, imgUploadPercentage: 0 })
                if (data.error) {
                    toast.error("Please Retry.")
                    return
                }
                _this.resetState()
                _this.setState({ ImageFiles: [] })
                _this.fetchCourse()

                toast.success("Successfully Uploaded !")
            } catch (error) {
                toast.error("Please Retry.")
                this.setState({ imgUploadPercentage: 0 })
            }
        }
    }
    uploadFileHandlerCustom = async (e) => {
        const file = e.target.files[0]
        if (file) {
            this.state.ImageFiles.push(file);
            this.state.imgSaveDisable = false
            this.setState(this.state)
        }
    }


    removeImage = (index) => {
        this.state.ImageFiles.splice(index, 1)
        this.setState(this.state)
    }
    removeImageFromDB = (obj) => {
        const url = `${process.env['REACT_APP_HOST']}/api/upload/removeimg/`;
        const params = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                img: obj,
                id: this.state.CourseOptput._id
            }),
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                if (data.error == false) {
                    toast.success("Successfully Deleted !")
                    this.fetchCourse();
                    return
                }
                toast.error("Please Retry.")
            })
    }
    LaunchCourse = () => {
        console.log("Object.keys(this.state.CourseOptput)");
        console.log(Object.keys(this.state.CourseOptput));

        if (Object.keys(this.state.CourseOptput).length > 0) {
            if (
                this.state.CourseOptput.images_collection.length > 0 &&
                this.state.CourseOptput.zip != "") {
                const thePath = window.location.href;
                const lastItem = thePath.substring(thePath.lastIndexOf('/') + 1)
                const url = `${process.env['REACT_APP_HOST']}/api/products/status/${lastItem}`;
                const params = {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        status: 1,
                    }),
                };
                fetch(url, params)
                    .then(response => response.json())
                    .then(data => {

                        if (data.message) {
                            toast.error("Please Retry !")

                        } else {
                            toast.success("Successfully Updated !")
                            setTimeout(() => {
                                this.props.history.push('/products/digital/digital-product-list');
                            }, 3000);
                        }

                    })

            } else {
                toast.error("Please upload zip file and images.")
            }
        }
    }
    DisableCourse = () => {
        if (Object.keys(this.state.CourseOptput).length > 0) {

            const thePath = window.location.href;
            const lastItem = thePath.substring(thePath.lastIndexOf('/') + 1)
            const url = `${process.env['REACT_APP_HOST']}/api/products/status/${lastItem}`;
            const params = {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    status: 0,
                }),
            };
            fetch(url, params)
                .then(response => response.json())
                .then(data => {

                    if (data.message) {
                        toast.error("Please Retry !")

                    } else {
                        toast.success("Successfully Updated !")
                        setTimeout(() => {
                            this.props.history.push('/products/digital/digital-product-list');
                        }, 3000);
                    }
                })
        }
    }
    render() {


        return (
            <div>
                <Fragment>
                    <Breadcrumb title={`Course Setup`} parent="Course" />
                    <ToastContainer />
                    <br />
                    {this.state.CourseOptput.zip == undefined ? null :
                        <div className="container-fluid">
                            <div className="row product-adding">
                                <div className="col-xl-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h5>Course Zip</h5>
                                                    {this.state.ZipUploded.name ?
                                                        <button type="button" onClick={this.saveZip} class="btn btn-primary float-right" disabled={this.state.zipSaveDisable}>Save Zip</button>
                                                        : null}
                                                </div>
                                                <div className="card-body">
                                                    <div className="digital-add needs-validation">

                                                        {this.state.CourseOptput.zip == "" ?
                                                            <div className="form-group">
                                                                <div className="row">
                                                                    <div className="col-4">
                                                                        <label className="col-form-label pt-0"> Product Zip </label>

                                                                    </div>
                                                                    <div className="col-8">
                                                                        <p> Add new zip package.</p>
                                                                        <input type="file" name="zip" accept=".zip" onChange={this.uploadZipHandler} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            :
                                                            <div>
                                                                <p>You have already uploded zip package.</p>
                                                                <input type="file" name="zip" accept=".zip" onChange={this.uploadZipHandler} />
                                                            </div>
                                                        }
                                                        <br />
                                                        <br />
                                                        {this.state.loadingZip ?
                                                            <>
                                                                <h4>Loading...</h4>
                                                                <div class="progress">
                                                                    <div class="progress-bar progress-bar-striped active" role="progressbar"
                                                                        aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style={{ width: `${this.state.zipUploadPercentage}%` }}>
                                                                        {this.state.zipUploadPercentage}%
                                                                </div>
                                                                </div>
                                                            </>
                                                            : null}
                                                    </div>
                                                </div>
                                            </div>
                                            {this.state.CourseOptput.images_collection ?
                                                this.state.CourseOptput.images_collection.length > 0 ?

                                                    <div className="card">
                                                        <div className="card-header">
                                                            <h5>Images Collection</h5>

                                                        </div>
                                                        <div className="card-body">
                                                            <div className="digital-add needs-validation">
                                                                <div className="form-group">
                                                                    <div className="row">
                                                                        <div style={{
                                                                            display: "grid",
                                                                            gridTemplateColumns: "1fr 1fr 1fr 1fr",
                                                                            gridColumnGap: "20px",
                                                                            gridRowGap: "20px"
                                                                        }}>

                                                                            {this.state.CourseOptput.images_collection.map((list, index) =>
                                                                                <div>
                                                                                    <img class="rounded" style={{ width: 200 }} src={`${process.env['REACT_APP_HOST']}/${list}`} />
                                                                                    <button onClick={() => this.removeImageFromDB(list)} type="button" class="btn btn-secondary btn-sm btn-lg btn-block">Remove</button>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : null
                                                : null}


                                            <div className="card">
                                                <div className="card-header">
                                                    <h5>Upload Images</h5>
                                                    {this.state.ImageFiles.length > 0 ?
                                                        <button onClick={this.saveImages} type="button" disabled={this.state.imgSaveDisable} class="btn btn-primary float-right">Save Images</button>
                                                        : null}
                                                </div>
                                                <div className="card-body">
                                                    <div className="digital-add needs-validation">
                                                        <div className="form-group">
                                                            <div className="row">
                                                                <div className="col-4">
                                                                    <label className="col-form-label pt-0"> Upload Image </label>
                                                                </div>
                                                                <div className="col-8">
                                                                    <input type="file" accept="image/*" name="image" onChange={this.uploadFileHandlerCustom} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {this.state.loadingImage ?
                                                            <>
                                                                <h4>Loading...</h4>
                                                                <div class="progress">
                                                                    <div class="progress-bar progress-bar-striped active" role="progressbar"
                                                                        aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style={{ width: `${this.state.imgUploadPercentage}%` }}>
                                                                        {this.state.imgUploadPercentage}%
                                                             </div>
                                                                </div>
                                                            </>
                                                            : null}
                                                        <br />
                                                        <div className="form-group">
                                                            <div className="row">
                                                                <div style={{
                                                                    display: "grid",
                                                                    gridTemplateColumns: "1fr 1fr 1fr 1fr",
                                                                    gridColumnGap: "20px",
                                                                    gridRowGap: "20px"
                                                                }}>
                                                                    {this.state.ImageFiles.map((list, index) =>
                                                                        <div>
                                                                            <img class="rounded" style={{ width: 200 }} src={URL.createObjectURL(list)} />
                                                                            <button onClick={() => this.removeImage(index)} type="button" class="btn btn-secondary btn-sm btn-lg btn-block">Remove</button>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card">
                                                <div className="card-header">
                                                    <h5>Launch Course</h5>
                                                </div>
                                                <div className="card-body">
                                                    <div className="digital-add needs-validation">
                                                        <div className="form-group">
                                                            <div className="row">
                                                                <div className="col-4">
                                                                    <label className="col-form-label pt-0"> Launch your course.  </label>
                                                                </div>
                                                                <div className="col-8">
                                                                    {this.state.CourseOptput.status == 1 ?
                                                                        <button onClick={this.DisableCourse} type="button" class="btn btn-primary float-right">Disable Course</button>
                                                                        :
                                                                        <button onClick={this.LaunchCourse} type="button" class="btn btn-primary float-right">Launch Course</button>
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-4">
                                                                    {this.state.CourseOptput.status == 1 ?
                                                                        <label className="col-form-label pt-0"> <span>*Note: </span>  </label>
                                                                        :
                                                                        <label className="col-form-label pt-0"> <span>*Note: </span>  </label>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </Fragment>
            </div >
        )
    }
}
